import type { App } from '@atlassian/jira-project-settings-apps-connect-apps/src/model/connect-apps/types.tsx';
import { JIRA_AUTOMATION_ADDON_KEY } from '../../constants.tsx';

const excludedConnectAddonKeys: string[] = [JIRA_AUTOMATION_ADDON_KEY];

export const filterServiceDeskConnectApps = (connectAppsData: App[] | null): App[] | null =>
	connectAppsData &&
	connectAppsData.filter(
		({ connectIframeProps }) =>
			// connectIframeProps should never be falsey, however we don't want exclusion by default
			!excludedConnectAddonKeys.includes(connectIframeProps ? connectIframeProps.addon_key : ''),
	);
